import { API_CRON, API_PICKER_EMP_MAPPING } from 'utils/constants'
import Api from './axiosInstance'
import { CustomObject } from 'types/common'

type FetchMasterDataParams = {
  limit: number
  page: number
}

export const getPickerMappingsApi = ({
  limit = 10,
  page = 1,
}: FetchMasterDataParams) => {
  const params = new URLSearchParams({
    limit: limit.toString(),
    page: page.toString(),
  })

  return Api.get({
    url: `${API_PICKER_EMP_MAPPING.PICKER_MAP}?${params}`,
  })
}

export const createPickerMappingApi = (data: CustomObject) => {
  return Api.post({
    url: API_PICKER_EMP_MAPPING.PICKER_MAP,
    data,
  })
}

export const updatePickerMappingApi = (id: string, data: CustomObject) => {
  return Api.patch({
    url: `${API_PICKER_EMP_MAPPING.PICKER_MAP}/${id}`,
    data,
  })
}

export const deletePickerMappingApi = (id: string) => {
  return Api.delete({
    url: `${API_PICKER_EMP_MAPPING.PICKER_MAP}/${id}`,
  })
}

export const importPickerMappingApi = async (data: any) => {
  return Api.post({
    url: API_PICKER_EMP_MAPPING.IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const exportPickerMappingApi = () => {
  return Api.get({
    url: API_PICKER_EMP_MAPPING.EXPORT,
  })
}

export const syncEmpIdApi = () => {
  return Api.post({
    url: API_CRON.CRON_SYNC_EMP_ID,
  })
}
